var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_900, Typography, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { getStatusCardAnimatedTextStyles } from './StatusCardAnimatedTextStyles';
export var StatusCardAnimatedText = props => {
  var _a;
  var animatedNumber = props.animatedNumber,
    withNumberSeparator = props.withNumberSeparator,
    style = props.style,
    testID = props.testID,
    restProps = __rest(props, ["animatedNumber", "withNumberSeparator", "style", "testID"]);
  var statusCardAnimatedTextStyles = getStatusCardAnimatedTextStyles();
  var _useState = useState(0),
    animatedNumberState = _useState[0],
    setAnimatedNumberState = _useState[1];
  var intervalRef = useRef(null);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  useEffect(() => {
    if (animatedNumber) {
      var iterations = 50;
      var differentToAdd = animatedNumber / iterations;
      intervalRef.current = setInterval(() => {
        iterations--;
        setAnimatedNumberState(prev => prev + differentToAdd);
        if (iterations === 0) {
          clearInterval(intervalRef.current);
        }
      }, 10);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
  var animatedNumberValue = withNumberSeparator ? !!animatedNumberState && Math.round(animatedNumberState).toLocaleString('en-IN') : animatedNumberState;
  var typographyProps = Object.assign(Object.assign({
    color: BLACK_900
  }, restProps), {
    style: [!!animatedNumberValue && statusCardAnimatedTextStyles.animatedNumber, statusCardAnimatedTextStyles.title, style],
    type: isLargeScreen ? 'body-para-xl-bold' : 'body-para-md-bold'
  });
  return _jsxs(View, Object.assign({
    style: statusCardAnimatedTextStyles.container
  }, {
    children: [!!animatedNumberValue && _jsx(Typography, Object.assign({}, getTestId(testID, 'number'), typographyProps, {
      text: "" + animatedNumberValue
    })), (!!(typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.text) || ((_a = typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.multiText) === null || _a === void 0 ? void 0 : _a.length) > 0) && _jsx(Typography, Object.assign({}, getTestId(testID, 'animated_multiText'), typographyProps))]
  }));
};